import { Box, Button } from '@mui/material';
import BugReportIcon from '@mui/icons-material/BugReport';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import StarIcon from '@mui/icons-material/Star';

function FeedbackFilterButtons({ filter, onFilter, feedback }) {
    const count = (typ) => feedback.filter((f) => f.typ === typ).length;

    return (
        <Box sx={{ mb: 4, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
            <Button
                fullWidth
                variant={filter === 'alle' ? 'contained' : 'outlined'}
                onClick={() => onFilter('alle')}
            >
                Alle ({feedback.length})
            </Button>
            <Button
                fullWidth
                variant={filter === 'fehler' ? 'contained' : 'outlined'}
                color="error"
                onClick={() => onFilter('fehler')}
                startIcon={<BugReportIcon />}
            >
                Fehler ({count('fehler')})
            </Button>
            <Button
                fullWidth
                variant={filter === 'verbesserung' ? 'contained' : 'outlined'}
                color="warning"
                onClick={() => onFilter('verbesserung')}
                startIcon={<TrendingUpIcon />}
            >
                Verbesserungen ({count('verbesserung')})
            </Button>
            <Button
                fullWidth
                variant={filter === 'wunsch' ? 'contained' : 'outlined'}
                color="info"
                onClick={() => onFilter('wunsch')}
                startIcon={<StarIcon />}
            >
                Wünsche ({count('wunsch')})
            </Button>
        </Box>
    );
}

export default FeedbackFilterButtons;
